import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, DatePicker, Form } from 'antd';

import { isFutureDate } from '@/views/Bera/_components/Filter/utils';

const { RangePicker } = DatePicker;

export function UpdatedAt(): JSX.Element {
	return (
		<Col xs={24}>
			<Form.Item name="updated_at" label={I18n.get('Date of update')} labelCol={{ span: 24 }}>
				<RangePicker style={{ width: '100%' }} format="DD-MM-YYYY" disabledDate={isFutureDate} />
			</Form.Item>
		</Col>
	);
}
